import { History } from 'history';

import { CreditCard } from '../../../../../hooks/useCreditCards';
import * as commonActions from '../../../common/cardActions';
import {
  CardActionDetails,
  CardActionProps,
  formatActionDetailsToActionCell,
  OperationActionId,
} from '../utils/cardActions';

const previousOperationId: OperationActionId = 'lock';

const LOCK: CardActionDetails = {
  ...commonActions.LOCK,
  iconName: 'clock',
  previousOperationId,
};

const MARK_AS_STOLEN: CardActionDetails = {
  ...commonActions.MARK_AS_STOLEN,
  previousOperationId,
};

const MARK_AS_LOST: CardActionDetails = {
  ...commonActions.MARK_AS_LOST,
  previousOperationId,
};

const DELETE: CardActionDetails = {
  ...commonActions.DELETE,
  iconName: 'trash',
  previousOperationId,
};

export function getCardActions(
  creditCard: CreditCard,
  history: History,
): CardActionProps[] {
  const { creditCardId, isPhysical } = creditCard;
  const actions: CardActionDetails[] = isPhysical
    ? [LOCK, MARK_AS_STOLEN, MARK_AS_LOST]
    : [LOCK, DELETE];

  return formatActionDetailsToActionCell(actions, creditCardId, history);
}
